import { render } from "./fixedBottom.vue?vue&type=template&id=0c1fcafc&scoped=true"
import script from "./fixedBottom.vue?vue&type=script&lang=js"
export * from "./fixedBottom.vue?vue&type=script&lang=js"

import "./fixedBottom.vue?vue&type=style&index=0&id=0c1fcafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1fcafc"]])

export default __exports__